<template lang='pug'>
  el-card.tp-audit(v-loading="loading")
    basic-info-view(
      :showMaterialInfo="true"
      :showRejectBtn="isOpen"
      @onConfirm="onConfirm"
      @openDialog="openDialog"
    )
    el-dialog(
      :title="$t('提示')"
      :visible.sync="visible"
    )
      div(
        v-if="subFinalScopeInfo != null && !subFinalScopeInfo.is_bypass"
        style="width: 100%;display:flex;justify-content:space-between"
      )
        span {{ $t('请选择驳回节点') }}:
        div
          el-radio(
            v-model="target_task_type"
            :label="1"
          ) {{ $t('修改投放人群') }}
          el-radio(
            v-model="target_task_type"
            :label="2"
          ) {{ $t('重新上传素材') }}
      el-form(
        ref="form"
        :model="form"
        :rules="rules"
      )
        el-form-item(
          :label="$t('拒绝理由') + ':'"
          prop="remark"
        )
          el-input(
            v-model="form.remark"
            type="textarea"
            :rows="3"
            style="width: 320px"
            :placeholder="$t('拒绝理由不多于500字')"
          )
      footer-button(
        :confirmButton="'确定'"
        @confirm="handleConfirm(2)"
        @cancel="handleCancel"
      )

    audit-versions(
      v-if="versions.length !== 0"
      :items="versions"
    )
</template>

<script>
import axios from 'axios'
import BasicInfoView from '../components/BasicInfoView'
import MediaTypeItemView from '../components/MediaTypeItemView'
import AuditVersions from '../components/AuditVersions'
import FooterButton from '@/components/FooterButton'

export default {
  components: {
    MediaTypeItemView,
    BasicInfoView,
    AuditVersions,
    FooterButton
  },
  data () {
    let validateIntro = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入拒绝理由')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('拒绝理由不多于100字')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      versions: [],
      visible: false,
      target_task_type: null,
      form: {
        remark: ''
      },
      rules: {
        remark: [
          {
            required: true, validator: validateIntro, trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    tabs () {
      return this.$store.state.campaign.ECTab
    },
    isOpen () {
      if (this.tabs == null || this.tabs.filter(i => i.tab_name === 'tab_tp_approve').length === 0) return false
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_tp_approve')
      return res[0].is_open
    },
    taskId () {
      if (this.tabs == null || this.tabs.filter(i => i.tab_name === 'tab_tp_approve').length === 0) return null
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_tp_approve')
      return res[0].task_id
    },
    subFinalScopeInfo () {
      return this.$store.state.campaign.subFinalScopeInfo
    }
  },
  mounted () {
    this.getApproveHistory()
  },
  methods: {
    openDialog (visible) {
      this.visible = visible
    },
    handleCommand (command) {
      if (command === 'handleApprove') {
        this.onConfirm(1)
      } else {
        this.target_task_type = 1
        this.visible = true
      }
    },
    handleConfirm (result) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.onConfirm(result)
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.target_task_type = null
      this.$refs['form'].clearValidate()
    },
    async onConfirm (result) {
      this.loading = true
      this.visible = false
      let params = {
        task_id: this.taskId,
        campaign_id: this.$store.state.campaign.id,
        sub_final_scope_id: this.$store.state.campaign.subFinalScopeId,
        approve_result: result,
        target_task_type: this.target_task_type,
        remark: this.form.remark
      }
      try {
        await axios.get('/management/ec/approveForTP', {
          params: params
        })
        await this.$store.dispatch('campaign/updateECTab')
        await this.getApproveHistory()
        this.$message.success(this.$t('提交成功'))
        this.loading = false
      } catch (err) {
        this.loading = false
        this.visible = false
        throw new Error(err)
      }
    },
    getApproveHistory () {
      axios.get('/management/subfinal/getMoreApproveHistory', {
        params: {
          id: this.$store.state.campaign.subFinalScopeId,
          audit_type: '25,28,32'
        }
      })
        .then(res => {
          this.versions = res
        })
        .catch(err => {
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang='stylus'>
.el-dropdown-menu
  width 90px
.tp-audit
  position relative
  .el-dialog
    width 452px
    .el-form
      margin-top 12px
      width 100%
      .el-form-item__error
        margin-left 80px
    .el-dialog__body
      padding-left 24px
      padding-right 24px
      display flex
      flex-direction column
      align-items center
      .el-textarea
        textarea.el-textarea__inner
          height 90px
</style>
